import script from "./settingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./settingsPage.vue?vue&type=script&setup=true&lang=js"

import "./settingsPage.vue?vue&type=style&index=0&id=65c996fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c996fb"]])

export default __exports__